if (!customElements.get('libertas-product-recommendations')) {
  class LibertasProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.recommendationsReady === 'true' || this.children.length > 0) return;
      this.dataset.recommendationsReady = 'true';
      this.abortController = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      delete this.dataset.recommendationsReady;
    }

    async load() {
      const url = this.dataset.recommendationsUrl;
      if (!url) return;

      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(`Recommendations request failed with ${response.status}`);

        const text = await response.text();
        const documentFragment = new DOMParser().parseFromString(text, 'text/html');
        const contentKey = this.dataset.recommendationsContent;
        const availableContent = [...documentFragment.querySelectorAll('[data-recommendations-content]')];
        const nextContent = contentKey
          ? availableContent.find((element) => element.dataset.recommendationsContent === contentKey)
          : availableContent[0];
        if (nextContent?.children.length > 0) this.innerHTML = nextContent.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.recommendationsError = 'true';
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('libertas-product-recommendations', LibertasProductRecommendations);
}
